import CreateMessageRCS from "./create-message-rcs";
class TestRCS extends CreateMessageRCS {
  constructor(data) {
    super(data);
  }

  file() {
    const { data } = this;

    const actions = this.actions(data.buttonActions);
    const suggestions = this.suggestions(data.buttonQuickReplies);

    const newData = {
      rcsMessage: {
        type: "file",
        fallBackMessage: data.fallback,
        fileUrl: data.imageUrl,
        thumbnail_url: data.thumbnail_url,
        actions: actions.concat(suggestions),
      },
    };

    this.deleteFields.forEach((field) => {
      delete newData[field];
    });

    return newData;
  }

  single() {
    const { data } = this;

    const actions = this.actions(data.buttonActions);
    const suggestions = this.suggestions(data.buttonQuickReplies);
    let newData = {
      message: this.formatEmoji(this.data.rcsmessage),
      rcsMessage: {
        type: "text",
        fallBackMessage: this.data.fallback,
        thumbnail_url: this.data?.thumbnail_url ?? null,
        image: this.data?.imageUrl ?? null,
        height: this.data?.height ?? "MEDIUM",
        cardWidth: this.data?.cardWidth ?? "MEDIUM",
        actions: actions.concat(suggestions),
      },
    };

    this.deleteFields.forEach((field) => {
      delete newData[field];
    });

    return newData;
  }

  rich() {
    const { data } = this;
    const actions = this.actions(data.buttonActions);
    const suggestions = this.suggestions(data.buttonQuickReplies);

    const newData = {
      message: this.formatEmoji(this.data?.rcsmessage ?? null), //this.data.rcsmessage,
      rcsMessage: {
        type: "richCard",
        fallBackMessage: this.data?.fallback,
        subtitle: this.formatEmoji(this.data?.rcsmessage ?? null),
        text: this.formatEmoji(this.data?.title_rcs_message ?? null),
        cardOrientation: this.data?.cardOrientation ?? "VERTICAL",
        image: this.data?.imageUrl ?? null,
        thumbnail_url: this.data?.thumbnail_url ?? null,
        height: this.data?.height ?? "MEDIUM",
        cardWidth: this.data?.cardWidth ?? "MEDIUM",
        actions: actions.concat(suggestions),
      },
    };

    this.deleteFields.forEach((field) => {
      delete newData[field];
    });

    return newData;
  }

  carrousel() {
    let newData = {
      message: this.formatEmoji(this.data.rcsmessage), //this.data.rcsmessage,
      rcsMessage: {
        type: "carouselCards",
        text: this.data.fallback,
        fallBackMessage: this.data.fallback,
        image: this.data.imageUrl,
        height: this.data.height ?? "MEDIUM",
        cardWidth: this.data.cardWidth ?? "MEDIUM",
        cards: this.data.carrousel.map(
          ({
            imageUrl,
            buttonActions,
            buttonQuickReplies,
            description,
            thumbnail_url,
            ...remain
          }) => {
            const actions = this.actions(buttonActions);
            const suggestions = this.suggestions(buttonQuickReplies);
            return {
              ...remain,
              description: this.formatEmoji(description),
              image: imageUrl ?? null,
              thumbnail_url: thumbnail_url ?? null,
              actions: actions.concat(suggestions),
            };
          },
        ),
      },
    };

    this.deleteFields.forEach((field) => {
      delete newData[field];
    });

    return newData;
  }

  buildTestData() {
    const step = this.data.step || 1;
    const hasFile = this.data.rcsmessage === undefined && step === 1;

    if (hasFile) {
      return this.file();
    }

    switch (step) {
      case 1:
        return this.single();
      case 2:
        return this.rich();
      case 3:
        return this.carrousel();
      default:
        return null;
    }
  }
}

export default TestRCS;
